import axios from "axios";
import cookie from "browser-cookies";


export const encode = (d) => JSON.stringify(d);
export const decode = (d) => JSON.parse(d);
export const retrieve = async (u) => {
  return await axios.get(u);
};

export const send = async (u, d) => {
  return await axios.post(u, d);
};

/**
 * Handles routing external or interally in application
 * @param {string} r - the url or path to route to example ['hello'] || ['www.hello.com'].
 * @param {string} w - provide 'locally' or 'external' to route correctly.
 * @param {string} h - pass the history hook for the page.
 */
export const handleRoute = (r, w, h) => {
  const route = {
    locally: () => (h ? h(r) : ""),
    external: () => window.open(r, "_blank"),
  };
  return route[w]();
};



/**
 * Handles checking browser cookie and local storage
 * @param {string} a - this appID
 * @param {string} p - the name of the page to check if cookie and local storage data exits - example 'home'.
 */
export const hasCookieAndStorage = (a, p) =>
  appCookie.get(a) !== null && appStore.get(`${a}${p}`) !== null;

/**
 * Handles setting browser cookie and local storage
 * @param {string} a - the appID
 * @param {string} p - the name of the page to set cookie and local storage data for.
 * @param {string} u - the url to fetch page data for - /api/home.
 * @param {string} s - pass the useState Hook here.
 */
export const setSessionData = (a, p, u, s) => {
  retrieve(u)
    .then((res) => {
      const pageData = {};
      pageData[p] = res.data;
      s(pageData);
      appStore.set(`${a}${p}`, encode(pageData));
      appCookie.set(a, "true");
    })
    .catch((err) => {
      console.log("error", err);
    });
};

export const appStore = {
  get: (k) => {
    return localStorage.getItem(k);
  },
  set: (k, v) => {
    return localStorage.setItem(k, v);
  },
  del: (k) => {
    return localStorage.removeItem(k);
  },
  clear: () => {
    return localStorage.clear();
  },
};

export const appCookie = {
  get: (k) => {
    return cookie.get(k);
  },
  set: (k, v, e) => {
    return cookie.set(k, v, { expires: e });
  },
  del: (k) => {
    return cookie.erase(k);
  },
};
